export class Filter {
    constructor(key, parse, stringify) {
        this.key = key;
        this.parse = parse;
        this.stringify = stringify;
    }
}
export class NumberFilter extends Filter {
    constructor(key) {
        super(key, (queryStr) => {
            if (!queryStr)
                return;
            const value = Number(queryStr);
            return isNaN(value) ? undefined : value;
        }, (value) => value.toString());
    }
}
export class StringFilter extends Filter {
    constructor(key) {
        super(key, (queryStr) => (queryStr ? queryStr : undefined), (value) => value);
    }
}
